import useAccountResourceService from '../accountResourceService';
import { SearchInput, FormFieldsData } from 'framework/form';

const mapResponse = (account: { accountId: any; accountName: any; hasCodeName: any; hasProjects: any }) => {
  return {
    id: account.accountId,
    text: account.accountName,
    accountName: account.accountName,
    hasAccountCodeName: account.hasCodeName,
    accountHasProjects: account.hasProjects,
  };
};

type AccountInputProps = {
  accountNameSource?: string;
  accountNameValue?: Nullable<string>;
  customMapResponse?: (account: { accountId: any; accountName: any; hasCodeName: any; hasProjects: any }) => any;
  labelHint?: string;
  label?: Nullable<string>;
  source?: string;
  onChangeCallback?: (values: FormFieldsData) => void;
  errorSource?: string;
  isVisible?: boolean | ((data: FormFieldsData) => boolean);
  required?: boolean;
  isRequired?: boolean;
  disabled?: boolean | ((values: FormFieldsData) => boolean);
  tooltip?: string;
  defaultFilter?: Object;
  onInputChangeCallback?: (resultValue: string) => void;
};

const AccountInput = ({ accountNameSource = 'accountName', accountNameValue = '', ...props }: AccountInputProps) => {
  const { search } = useAccountResourceService();
  const { customMapResponse } = props;

  return (
    <SearchInput
      searchRequest={search}
      noResultMessage="No Accounts are found."
      mapResults={customMapResponse || mapResponse}
      initialLabel={accountNameValue}
      nameSource={accountNameSource}
      {...props}
    />
  );
};

export default AccountInput;
